import { render } from "./ElencoCommesse.vue?vue&type=template&id=a2991b66"
import script from "./ElencoCommesse.vue?vue&type=script&lang=js"
export * from "./ElencoCommesse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__